import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Layouts
import MainLayout from './layouts/MainLayout';
import DashboardLayout from './layouts/DashboardLayout';
//test change
// Public Pages
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Products from './pages/Products';
import Academy from './pages/Academy';
import Services from './pages/Services';
import NotFound from './pages/NotFound';
import MeetOurDeveloper from './pages/MeetOurDeveloper';
import VerifyCertificate from './pages/VerifyCertificate';

// Auth Pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';

// Dashboard Pages
import Dashboard from './pages/dashboard/Dashboard';
import MyCourses from "./pages/dashboard/MyCourses";
import DashboardCourseDetail from "./pages/dashboard/CourseDetail";
import LessonDetail from "./pages/dashboard/LessonDetail";
import Profile from "./pages/dashboard/Profile";
import Settings from "./pages/dashboard/Settings";
import LiveClass from "./pages/dashboard/LiveClass";

// Student Management Pages
import StudentList from "./components/dashboard/StudentList";
import StudentDetails from "./components/dashboard/StudentDetails";

// Analytics
import AdvancedAnalytics from "./components/dashboard/AdvancedAnalytics";

// Gamification
import Gamification from "./components/dashboard/Gamification";

// Protected Route Component
import ProtectedRoute from './components/common/ProtectedRoute';

function App() {
  return (
    <>
      <Routes>
        {/* Public Routes with MainLayout */}
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="products" element={<Products />} />
          <Route path="academy" element={<Academy />} />
          <Route path="services" element={<Services />} />
          <Route path="meet-our-developer" element={<MeetOurDeveloper />} />
          <Route path="verify" element={<VerifyCertificate />} />
          <Route path="*" element={<NotFound />} />
          
          {/* Auth Routes */}
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password/:resetToken" element={<ResetPassword />} />
        </Route>
        
        {/* Dashboard Routes - Protected */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Dashboard />} />
          <Route path="profile" element={<Profile />} />
          <Route path="settings" element={<Settings />} />
          <Route path="courses" element={<MyCourses />} />
          <Route path="courses/:courseId" element={<DashboardCourseDetail />} />
          <Route path="courses/:courseId/lessons/:lessonId" element={<LessonDetail />} />
          <Route path="live-class" element={<LiveClass />} />
          <Route path="gamification" element={<Gamification />} />
          
          {/* Student Management Routes */}
          <Route path="students" element={<StudentList />} />
          <Route path="students/:studentId" element={<StudentDetails />} />
          <Route path="enrollments" element={<StudentList />} />
          <Route path="progress" element={<StudentList />} />
          <Route path="support/create" element={<StudentList />} />
          <Route path="support/reports" element={<StudentList />} />
          
          {/* Analytics Route */}
          <Route path="analytics" element={<AdvancedAnalytics />} />
        </Route>
      </Routes>
      
      <ToastContainer position="bottom-right" />
    </>
  );
}

export default App;